// extracted by mini-css-extract-plugin
export var alignCenter = "_bm-d";
export var bannerShown = "_bm-6";
export var buttonContent = "_bm-0";
export var cardList = "_bm-1";
export var centerContent = "_bm-2";
export var chevron = "_bm-3";
export var closePanelButton = "_bm-k";
export var conversationContextContainer = "_bm-l";
export var conversationDetailContainer = "_bm-4";
export var detailWrapper = "_bm-7";
export var dropdownButton = "_bm-e";
export var dropdownTitle = "_bm-9";
export var fullHeight = "_bm-5";
export var hidden = "_bm-a";
export var icon = "_bm-b";
export var mergeSuggestionWrapper = "_bm-m";
export var panel = "_bm-i";
export var portalButtonsWrapper = "_bm-c";
export var right = "_bm-j";
export var tableSummaryContainer = "_bm-8";
export var tableSummaryHeader = "_bm-g";
export var threeDotsButton = "_bm-f";
export var wide = "_bm-h";